import { FormattedMessage, useIntl } from "react-intl";
import Modal from "../../Modal";
import styles from "./styles.module.css";
import FormField from "../../FormField";
import { useState } from "react";
import UnsavedModal from "../../UnsavedModal";
import useTracker from "../../../hooks/useTracker";
import { useSelector } from "react-redux";

const DeleteIdentityModal = ({
  modalOpen,
  setModalOpen,
  onDelete,
  loading,
}) => {
  const intl = useIntl();
  const { trackDeleteIdentity } = useTracker();

  const trackerDeatils = useSelector((state) => state?.TrackerReducer);

  const [isUnsavedModalOpen, setIsUnsavedModalOpen] = useState(false);
  const [deleteFormData, setDeleteFormData] = useState(
    trackerDeatils?.delete_form?.snowId
      ? { snowId: trackerDeatils?.delete_form?.snowId }
      : {}
  );

  //#region delete modal handle functions
  const handleTicketChange = (e) => {
    setDeleteFormData({ [e.target.name]: e.target.value });
    trackDeleteIdentity({ [e.target.name]: e.target.value });
  };
  const handleDelete = () => {
    setDeleteFormData((prev) => ({ ...prev, hasSubmitted: true }));
    if (deleteFormData?.snowId?.trim())
      onDelete(deleteFormData?.snowId?.trim());
  };
  const handleClose = (status) => {
    if (deleteFormData?.snowId?.trim()) setIsUnsavedModalOpen(true);
    else setModalOpen(false);
  };
  //#endregion

  //#region unsaved modal handle functions
  const handleDiscardDelete = (status) => {
    setDeleteFormData({});
    trackDeleteIdentity({});
    setIsUnsavedModalOpen(false);
    setModalOpen(false);
  };
  const handleContinue = () => {
    setIsUnsavedModalOpen(false);
  };
  //#endregion

  return (
    <>
      <Modal
        title={intl.formatMessage({
          id: "confirm-delete-identity",
          defaultMessage: "Delete main identity",
        })}
        okText="Delete Identity"
        deletePrimary={true}
        open={modalOpen}
        setOpen={setModalOpen}
        isDisabled={loading}
        onSubmit={handleDelete}
        handleClose={handleClose}
        handleClickOutside={handleClose}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div>
            <h2 className={styles["modal-heading"]}>
              <FormattedMessage
                id="delete.main-identity-title"
                defaultMessage="Are you sure you want to delete this identity?"
              />
            </h2>
            <p className={styles["modal-message"]}>
              <FormattedMessage
                id="delete.main-identity-description"
                defaultMessage="To delete this main identity, please add the relevant SNOW ticket no. below"
              />
            </p>
          </div>
          <FormField
            value={deleteFormData?.snowId}
            name="snowId"
            type="text"
            id="snowId"
            label="SNOW ticket no."
            placeHolder={intl.formatMessage({
              id: "id.placeholder.snow-id",
              defaultMessage: "Please fill the SNOW ticket no.",
            })}
            handleChange={handleTicketChange}
            rules={{
              required: true,
              hasSubmitted: deleteFormData?.hasSubmitted,
            }}
          />
        </div>
      </Modal>
      <UnsavedModal
        title={intl.formatMessage({
          id: "unsaved.title",
          defaultMessage: "Unsaved changes",
        })}
        subTitle={intl.formatMessage({
          id: "unsaved.subtitle",
          defaultMessage: "Are you sure you want to leave?",
        })}
        description={intl.formatMessage({
          id: "unsaved.deletion.description",
          defaultMessage:
            "The deletion is not completed yet. Are you sure you want to close and discard changes? ",
        })}
        open={isUnsavedModalOpen}
        setOpen={setIsUnsavedModalOpen}
        okText={intl.formatMessage({
          id: "unsaved.discardchanges",
          defaultMessage: "Discard changes",
        })}
        canelText={intl.formatMessage({
          id: "label.cancel",
          defaultMessage: "Cancel",
        })}
        handleClose={handleContinue}
        handleDiscard={handleDiscardDelete}
      />
    </>
  );
};

export default DeleteIdentityModal;
